import {
  FETCH_PURITIES_REQUEST,
  FETCH_PURITIES_SUCCESS,
  FETCH_PURITIES_FAILURE,
  CREATE_PURITY,
  UPDATE_PURITY,
  DELETE_PURITY,
} from '../../types/purity/purityTypes';

const initialState = {
  purities: [],
  loading: false,
  error: null,
};

const purityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PURITIES_REQUEST:
      return { ...state, loading: true };

    case FETCH_PURITIES_SUCCESS:
      return { ...state, loading: false, purities: action.payload };

    case FETCH_PURITIES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    
    case CREATE_PURITY:
  return {
    ...state,
    purities: [...state.purities, action.payload],
  };

    case DELETE_PURITY:
      return {
        ...state,
        purities: state.purities.filter((d) => d.id !== action.payload),
      };

    case UPDATE_PURITY:
      return {
        ...state,
        purities: state.purities.map((d) =>
          d.id === action.payload.id ? { ...d, ...action.payload.data } : d
        ),
      };

    default:
      return state;
  }
};

export default purityReducer;
